<template>
    <div class="card">
        <Accordion :activeIndex="0">
            <AccordionTab header="취업보호·장려">
                <div class="p-grid p-formgrid p-mb-3">
                    <div class="p-col-12 p-mb-2 p-lg-4" v-for="item in employment_protection_and_promotion" :key="item.id">
                        <Checkbox v-model="employment_Data.conditions" :inputId="item.id" :value="item.message" @input="employmentcheck($event)" />
                        <label :for="item.id" class="ml-3" style="margin-left: 10px;">{{ item.message }} </label>
                    </div>
                </div>
            </AccordionTab>
            <AccordionTab header="자격·능력">
                <div class="p-grid p-formgrid p-mb-3">
                    <div class="p-col-12 p-mb-2 p-lg-4" v-for="item in qualifications_and_abilities" :key="item.id">
                        <Checkbox v-model="qualification_Data.conditions" :inputId="item.id" :value="item.message" @input="qualificationcheck($event)" />
                        <label :for="item.id" class="ml-3" style="margin-left: 10px;">{{ item.message }} </label>
                    </div>
                </div>
            </AccordionTab>
            <AccordionTab header="활동·경험">
                <div class="p-grid p-formgrid p-mb-3">
                    <div class="p-col-12 p-mb-2 p-lg-4" v-for="item in activities_or_experiences" :key="item.id">
                        <Checkbox v-model="activity_Data.conditions" :inputId="item.id" :value="item.message" @input="activitycheck($event)" />
                        <label :for="item.id" class="ml-3" style="margin-left: 10px;">{{ item.message }} </label>
                    </div>
                </div>
            </AccordionTab>
            <AccordionTab header="근무조건">
                <div class="p-grid p-formgrid p-mb-3">
                    <div class="p-col-12 p-mb-2 p-lg-4" v-for="item in working_conditions" :key="item.id">
                        <Checkbox v-model="working_condition_Data.conditions" :inputId="item.id" :value="item.message" @input="workingcheck($event)" />
                        <label :for="item.id" class="ml-3" style="margin-left: 10px;">{{ item.message }} </label>
                    </div>
                </div>
            </AccordionTab>
        </Accordion>
    </div>
    <!-- ---headeer -->
    <div style="display: flex; justify-content: space-between" class="p-mb-0">
        <h5>선택한 우대조건</h5>
        <!-- <Button label="Add" icon="pi pi-plus" size="small"/> -->
        <Tag value="직접 추가" icon="pi pi-plus" @click="directmodal = true"></Tag>
    </div>
    <Divider />

    <div class="card">
        <div class="p-field">
            <label for="pass"><b>취업보호·장려</b></label>
        </div>
        <div class="p-mt-0">
            <Tag class="p-mr-3" v-for="item in employment_Data.conditions" :key="item">
                <div class="flex align-items-center gap-2">
                    <span class="text-base">{{ item }}</span>
                    <i class="pi pi-times text-xs" @click="removeItemOnce(employment_Data.conditions, employment_Data.conditions.indexOf(item))"></i>
                </div>
            </Tag>
        </div>
    </div>
    <div class="card">
        <div class="p-field">
            <label for="pass"><b>자격·능력</b></label>
        </div>
        <div class="p-mt-0">
            <Tag class="p-mr-3" v-for="item in qualification_Data.conditions" :key="item">
                <div class="flex align-items-center gap-2">
                    <span class="text-base">{{ item }}</span>
                    <i class="pi pi-times text-xs" @click="removeItemOnce(qualification_Data.conditions, qualification_Data.conditions.indexOf(item))"></i>
                </div>
            </Tag>
        </div>
    </div>
    <div class="card">
        <div class="p-field">
            <label for="pass"><b>활동·경험</b></label>
        </div>
        <div class="p-mt-0">
            <Tag class="p-mr-3" v-for="item in activity_Data.conditions" :key="item">
                <div class="flex align-items-center gap-2">
                    <span class="text-base">{{ item }}</span>
                    <i class="pi pi-times text-xs" @click="removeItemOnce(activity_Data.conditions, activity_Data.conditions.indexOf(item))"></i>
                </div>
            </Tag>
        </div>
    </div>
    <div class="card">
        <div class="p-field">
            <label for="pass"><b>근무조건</b></label>
        </div>
        <div class="p-mt-0">
            <Tag class="p-mr-3" v-for="item in working_condition_Data.conditions" :key="item">
                <div class="flex align-items-center gap-2">
                    <span class="text-base">{{ item }}</span>
                    <i class="pi pi-times text-xs" @click="removeItemOnce(working_condition_Data.conditions, working_condition_Data.conditions.indexOf(item))"></i>
                </div>
            </Tag>
        </div>
    </div>
    <div class="card">
        <div class="p-field">
            <label for="pass"><b>우대조건 직접 추가</b></label>
        </div>
        <div class="p-mt-0">
            <Tag class="p-mr-3" v-for="item in inputList" :key="item">
                <div class="flex align-items-center gap-2">
                    <span class="text-base">{{ item }}</span>
                    <i class="pi pi-times text-xs" @click="removeItemOnce(inputList, inputList.indexOf(item))"></i>
                </div>
            </Tag>
        </div>
    </div>
    <Dialog v-model:visible="directmodal" modal header="우대조건 직접 추가" :style="{ width: '30vw' }">
        <div class="p-m-5">
            <InputText v-model="addinput" class="p-lg-8 p-mr-2" placeholder="옵션 입력" id="tagtext"/>
            <Button label=" 추가 " class="p-lg-3" icon="pi pi-check" @click="setList(addinput)" autofocus id="tagbtn"/>
        </div>
        <div class="card">
            <div class="p-field p-ml-2">
                <label for="pass"><b>직접 추가한 우대조건</b></label>
            </div>
            <Tag class="p-mr-3 p-ml-2" v-for="item in inputList" :key="item">
                <div class="flex align-items-center gap-2">
                    <span class="text-base">{{ item }}</span>
                    <i class="pi pi-times text-xs" @click="removeItemOnce(inputList, inputList.indexOf(item))"></i>
                </div>
            </Tag>
        </div>
        <template #footer>
            <Button label=" 확인 " @click="directmodal = false" autofocus style="width: 100%" />
        </template>
    </Dialog>
</template>
<script>
export default {
    data() {
        return {
            addinput: '',
            inputList: [],
            rejectModal: false,
            directmodal: false,
            employment_protection_and_promotion: [
                { id: 1, message: '국가유공자' },
                { id: 2, message: '보훈대상자' },
                { id: 3, message: '장애인우대' },
                { id: 4, message: '외국인우대' },
                { id: 5, message: '병역특례' },
                { id: 6, message: '주부(전업주부)' },
                { id: 7, message: '고령자(55세이상)' },
                { id: 8, message: '취업보호대상자' },
                { id: 9, message: '고용촉진장려금 대상' },
                { id: 10, message: '특성화고/마이스터고' },
            ],
            employeementdiv: false,
            qualificationdiv: false,
            activitydiv: false,
            workingdiv: false,
            directdiv: false,
            employment_Data: {
                type: 'employment_protection_and_promotion',
                conditions: [],
            },
            qualifications_and_abilities: [
                { id: 1, message: '학점4.0 이상' },
                { id: 2, message: '통계분석능숙자' },
                { id: 3, message: '컴퓨터활용능력 우수' },
                { id: 4, message: '문서작성 우수자' },
                { id: 5, message: '엑셀 고급능력자' },
                { id: 6, message: '더존/회계 능숙자' },
                { id: 7, message: 'CAD/CAM 능숙자' },
                { id: 8, message: '포토샵 능숙자' },
                { id: 9, message: 'FLASH 능숙자' },
                { id: 10, message: 'MAC/편집 전문가' },
                { id: 11, message: 'PPT능력 우수자' },
                { id: 12, message: '영어가능자' },
                { id: 13, message: '영어능통자' },
                { id: 14, message: '일본어 가능자' },
                { id: 15, message: '중국어 가능자' },
                { id: 16, message: '불어 가능자' },
                { id: 17, message: '스페인어 가능자' },
                { id: 18, message: '러시아어 가능자' },
                { id: 19, message: '베트남어 가능자' },
                { id: 20, message: '아랍어 가능자' },
                { id: 21, message: '독일어 가능자' },
            ],
            qualification_Data: {
                type: 'qualifications_and_abilities',
                conditions: [],
            },
            activities_or_experiences: [
                { id: 1, message: '공모전 입상자' },
                { id: 2, message: '해당직무 인턴경력' },
                { id: 3, message: '해당직무 알바경험' },
                { id: 4, message: '해당직무 근무경험' },
                { id: 5, message: '해외연수자' },
                { id: 6, message: '사회봉사활동 경험' },
                { id: 7, message: '군전역간부' },
                { id: 8, message: 'MBA학위 수여자' },
                { id: 9, message: ' 우수사원 수상자' },
                { id: 10, message: '석사학위 수여자' },
                { id: 11, message: '박사학위 수여자' },
            ],
            activity_Data: {
                type: 'activities_or_experiences',
                conditions: [],
            },
            working_conditions: [
                { id: 1, message: '인근거주자' },
                { id: 2, message: '운전가능자' },
                { id: 3, message: '차량소지자' },
                { id: 4, message: '기숙사 생활가능자' },
                { id: 5, message: '해외근무 가능자' },
                { id: 6, message: '지방근무 가능자' },
                { id: 7, message: '야간근무 가능자' },
                { id: 8, message: '격일근무 가능자' },
                { id: 9, message: '2교대근무 가능자' },
                { id: 10, message: '3교대근무 가능자' },
                { id: 11, message: '단기근무 가능자' },
                { id: 12, message: '장기근무 가능자' },
            ],
            working_condition_Data: {
                type: 'working_conditions',
                conditions: [],
            },
            directly: {
                type: 'directly',
                conditions: [],
            },
        };
    },
    methods: {
        sendCondition() {
            this.$emit('conditionData', [this.employment_Data, this.qualification_Data, this.activity_Data, this.working_condition_Data, this.directly]);
        },
        setList(input) {
            this.inputList.push(input);
            this.addinput = '';
        },
        employmentcheck(e) {
            if (e) {
                console.log('Employment-data', this.employment_Data);
            }
        },
        qualificationcheck(e) {
            if (e) {
                console.log('Qualification-data', this.qualification_Data);
            }
        },
        activitycheck(e) {
            if (e) {
                console.log('Activity-data', this.activity_Data);
            }
        },
        workingcheck(e) {
            if (e) {
                console.log('working-conditions-data', this.working_condition_Data);
            }
        },
        removeItemOnce(arr, value) {
            var index = arr.indexOf(value);
            if (index > -1) {
                arr.splice(index, 1);
            }
            return arr.splice(index, 1);
        },
    },
};
</script>
<style scoped>
button#tagbtn {
    width: auto;
    height: 39px;
}
input#tagtext {
    height: 40px;
}
</style>
